import { createInput } from '@formkit/vue'
import Rating from './Rating.vue'

export default createInput(Rating, {
  props: ['maxRating']
})